import { z } from "zod";
export const themeColorPaletteNames = [
    "Snow",
    "SunGlow",
    "Cantaloupe",
    "Blush",
    "Fandango",
    "Lilac",
    "CornflowerBlue",
    "Mint",
    "Lime",
    "Onyx",
    "Gold",
    "Rust",
    "Ruby",
    "DarkCherry",
    "Plum",
    "Azure",
    "Emerald",
    "Olive",
    "Forest",
    "Teal",
    "Blue",
    "Maroon",
    "Aurum",
    "Gray",
    "Black",
    "DoodleCoffee",
    "StarPop",
    "MeadowFlowers",
    "MountainView",
    "BigCongrats",
    "SchoolSpirit",
    "ChristmasPresents",
    "HolidaySnow",
];
export const themeColorPaletteNameSchema = z.enum(themeColorPaletteNames);
export const themeColorPalettes = {
    Snow: {
        pickerSwatch: "rgb(255,255,255)",
        background: "lightgray",
        faceClipBorder: "black",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    SunGlow: {
        pickerSwatch: "rgb(227,210,115)",
        background: "rgb(224, 208, 114)",
        faceClipBorder: "rgba(255, 255, 255,0.5)",
        introText: "rgba(255, 255, 255,0.85)",
        greetingText: "rgba(255, 255, 255,0.85)",
        captionText: "rgba(255, 255, 255,0.85)",
    },
    Cantaloupe: {
        pickerSwatch: "rgb(228,161,98)",
        background: "rgb(214, 140, 66)",
        faceClipBorder: "rgb(207, 114, 21)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Blush: {
        pickerSwatch: "rgb(230,133,127)",
        background: "rgb(227, 163, 159)",
        faceClipBorder: "rgb(219, 147, 182)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Fandango: {
        pickerSwatch: "rgb(179,111,164)",
        background: "rgb(94, 63, 97)",
        faceClipBorder: "rgb(148, 70, 156)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Lilac: {
        pickerSwatch: "rgb(128,108,187)",
        background: "rgb(141, 93, 145)",
        faceClipBorder: "rgb(102, 98, 115)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    CornflowerBlue: {
        pickerSwatch: "rgb(92,122,183)",
        background: "rgb(92,122,183)",
        faceClipBorder: "rgb(35, 48, 74)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Mint: {
        pickerSwatch: "rgb(115,187,161)",
        background: "rgb(148, 227, 198)",
        faceClipBorder: "rgb(7, 77, 49)",
        introText: "rgb(225, 250, 240)",
        greetingText: "rgb(225, 250, 240)",
        captionText: "rgb(225, 250, 240)",
    },
    Lime: {
        pickerSwatch: "rgb(142,176,113)",
        background: "rgb(161, 191, 136)",
        faceClipBorder: "rgb(64, 92, 39)",
        introText: "rgb(222, 227, 218)",
        greetingText: "rgb(222, 227, 218)",
        captionText: "rgb(222, 227, 218)",
    },
    Onyx: {
        pickerSwatch: "rgb(41,41,50)",
        background: "rgb(41,41,50)",
        faceClipBorder: "rgb(64, 92, 39)",
        introText: "rgb(222, 227, 218)",
        greetingText: "rgb(222, 227, 218)",
        captionText: "rgb(222, 227, 218)",
    },
    Gold: {
        pickerSwatch: "rgb(173,153,91)",
        background: "rgb(140, 121, 60)",
        faceClipBorder: "rgb(150, 124, 33)",
        introText: "rgb(240, 236, 225)",
        greetingText: "rgb(240, 236, 225)",
        captionText: "rgb(240, 236, 225)",
    },
    Rust: {
        pickerSwatch: "rgb(178,96,33)",
        background: "rgb(145, 52, 23)",
        faceClipBorder: "rgb(204, 97, 63)",
        introText: "rgba(255, 255, 255,0.85)",
        greetingText: "rgba(255, 255, 255,0.85)",
        captionText: "rgba(255, 255, 255,0.85)",
    },
    Ruby: {
        pickerSwatch: "rgb(188,73,63)",
        background: "rgb(143, 55, 49)",
        faceClipBorder: "rgb(130, 10, 4)",
        introText: "rgb(252, 222, 220)",
        greetingText: "rgb(252, 222, 220)",
        captionText: "rgb(252, 222, 220)",
    },
    DarkCherry: {
        pickerSwatch: "rgb(133,61,92)",
        background: "rgb(74, 30, 49)",
        faceClipBorder: "rgb(143, 90, 113)",
        introText: "rgb(252, 235, 242)",
        greetingText: "rgb(252, 235, 242)",
        captionText: "rgb(252, 235, 242)",
    },
    Plum: {
        pickerSwatch: "rgb(104,73,129)",
        background: "rgb(60, 39, 77)",
        faceClipBorder: "rgb(209, 178, 247)",
        introText: "rgb(230, 215, 247)",
        greetingText: "rgb(230, 215, 247)",
        captionText: "rgb(230, 215, 247)",
    },
    Azure: {
        pickerSwatch: "rgb(55,84,141)",
        background: "rgb(53,71,99)",
        faceClipBorder: "rgb(23,29,43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Emerald: {
        pickerSwatch: "rgb(68,131,107)",
        background: "rgb(36, 94, 72)",
        faceClipBorder: "rgb(208, 245, 232)",
        introText: "rgb(240, 252, 248)",
        greetingText: "rgb(240, 252, 248)",
        captionText: "rgb(240, 252, 248)",
    },
    Olive: {
        pickerSwatch: "rgb(97,120,77)",
        background: "rgb(62, 79, 47)",
        faceClipBorder: "rgb(230, 250, 212)",
        introText: "rgb(243, 250, 237)",
        greetingText: "rgb(243, 250, 237)",
        captionText: "rgb(243, 250, 237)",
    },
    Forest: {
        pickerSwatch: "rgb(69,100,72)",
        background: "rgb(69,100,72)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Teal: {
        pickerSwatch: "rgb(66,123,125)",
        background: "rgb(66,123,125)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Blue: {
        pickerSwatch: "rgb(54,77,95)",
        background: "rgb(54,77,95)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Maroon: {
        pickerSwatch: "rgb(125,66,75)",
        background: "rgb(125,66,75)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Aurum: {
        pickerSwatch: "rgb(229,186,112)",
        background: "rgb(229,186,112)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Gray: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    Black: {
        pickerSwatch: "rgb(0,0,0)",
        background: "rgb(0,0,0)",
        faceClipBorder: "rgb(0, 0, 0)",
        introText: "white",
        greetingText: "white",
        captionText: "white",
    },
    DoodleCoffee: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "#ffa400",
        greetingText: "#ffffff",
        captionText: "#2b261f",
    },
    StarPop: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "rgb(23, 29, 43)",
        introText: "#91a0b6",
        greetingText: "#ffffff",
        captionText: "#ffffff",
    },
    MeadowFlowers: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#fffef2",
        introText: "#cb6a59",
        greetingText: "#cb6a59",
        captionText: "#cb6a59",
    },
    MountainView: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#ece5b4",
        introText: "#293435",
        greetingText: "#293435",
        captionText: "#293435",
    },
    BigCongrats: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#000000",
        introText: "#bc4b4d",
        greetingText: "#bc4b4d",
        captionText: "#ffffff",
    },
    SchoolSpirit: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#fff",
        introText: "#fff",
        greetingText: "#fff",
        captionText: "#fff",
    },
    ChristmasPresents: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#fff",
        introText: "#b64c4a",
        greetingText: "#b64c4a",
        captionText: "#b64c4a",
    },
    HolidaySnow: {
        pickerSwatch: "rgb(49,51,56)",
        background: "rgb(49,51,56)",
        faceClipBorder: "#fff",
        introText: "#fff",
        greetingText: "#fff",
        captionText: "#fff",
    },
};
